import React from 'react';
import { UseAllowedEnumResource } from './types';
import useAccountIdentity from './useAccountIdentity';

const useAllowedEnumResource: UseAllowedEnumResource = (
  userId,
  { resourceName, permission, defaultValues, uppercase },
) => {
  const { getResourceAccess, loading } = useAccountIdentity(userId);

  // Check values
  const allowedValues = React.useMemo(() => {
    if (loading) return [];

    const resourceAccess = getResourceAccess(resourceName, permission);

    // If all permissions given, return the defaultValues
    if (resourceAccess.type === 'all') return defaultValues;
    // If no permission given, return empty array
    if (resourceAccess.type === 'none') return [];

    // If uppercase comparison, convert resourceAccess.list to uppercase
    if ('list' in resourceAccess && uppercase) {
      resourceAccess.list = resourceAccess.list.map((v) => v.toUpperCase());
    }

    return defaultValues.filter((v) => {
      if (resourceAccess.type === 'allowlist') {
        return resourceAccess.list.includes(v);
      }
      if (resourceAccess.type === 'denylist') {
        return !resourceAccess.list.includes(v);
      }
      return false;
    });
  }, [
    defaultValues,
    getResourceAccess,
    loading,
    permission,
    resourceName,
    uppercase,
  ]);

  return {
    loading,
    allowedValues,
  };
};

export default useAllowedEnumResource;
